export const GET_NOTIFICATION_SETTINGS = 'GET_NOTIFICATION_SETTINGS'
export const UPDATE_NOTIFICATION_SETTING = 'UPDATE_NOTIFICATION_SETTING'
